/**
 * JavaScript counterpart of the global CSS design tokens.
 *
 * Use these values only when an API needs a resolved color (for example,
 * Material UI themes or canvas charts). DOM styles should use the CSS custom
 * properties from global/_design-tokens.scss.
 */
export const keaPalette = Object.freeze({
  primary: '#26845F',
  primaryHover: '#1F704F',
  primaryActive: '#15563D',
  primarySoft: '#E4F4ED',
  primarySurface: '#F6FBF9',
  primaryBorder: '#C9D9D3',
  onPrimary: '#FFFFFF',
});

export default keaPalette;
